// Mock data for Jon Ortega's Portfolio
export const portfolioData = {
  personal: {
    name: "Jon Ortega",
    title: "Data&AI engineer",
    subtitle: "Building AI solutions that empower and elevate society",
    location: "on a mission",
    bio: [
      //"AI power user dedicated to contribute to mass adoption on SMBs and education.",
      //"I love connecting with people and exploring new ways of thinking and building.",
    ]
  },

  fellowships: [
    {
      name: "Silicon Valley Fellowship",
      description: "Mentorship program in SF with top founders worldwide",
      logo: "/carrousel/silicon-valley-fellowship.png",
      url: "https://www.siliconvalleyfellowship.com/"
    },
    {
      name: "First Ascent",
      description: "4-day event in Milan for 20 of Spain's best engineers",
      logo: "/carrousel/bending-spoons-first-ascent.png",
      url: "https://spain.firstascent.io/"
    },
    {
      name: "Eurotech Federation",
      description: "80 top builders came together at the RAISE Summit",
      logo: "/carrousel/eurotech-federation.png",
      url: "https://eurotech-federation.com/"
    },
    {
      name: "The Exponential Fellowship",
      description: "The bridge between Spain and Silicon Valley",
      logo: "/carrousel/the-exponential-fellowship.jpg",
      url: "https://www.goexponential.org/"
    },
    {
      name: "NOVA Talent",
      description: "Europe's leading top-talent community",
      logo: "/carrousel/nova-talent.jpg",
      url: "https://www.novatalent.com/"
    },
    {
      name: "Emergent Ventures",
      description: "Tyler Cowen's fund: received $5,000",
      logo: "/carrousel/emergent-ventures.png",
      url: "https://www.mercatus.org/emergent-ventures"
    },
    {
      name: "AIESEC",
      description: "Global youth org offering international internships",
      logo: "/carrousel/aiesec.jpg",
      url: "https://aiesec.org/"
    }
  ],

  wrappersAI: {
    title: "Wrappers AI",
    role: "Co-founder & CEO",
    description: "Leading AI agents revolution for mass adoption. Working on infinite memory, context-rich, agentic use cases for SMBs.",
    responsibilities: [
      "Product roadmap design and strategic planning",
      "Leading technical architecture decisions",
      "Building scalable AI agent infrastructure"
    ],
    techStack: ["FastAPI", "NextJS", "TypeScript", "Context Engineering", "Tool use", "MCPs"]
  },

  workExperience: [
    {
      company: "We Are Clickers",
      roles: ["Data Scientist", "AI Full-Stack Dev"],
      duration: "Sep 2023 - June 2025",
      description: "Started as Data Scientist, evolved to AI Full-Stack Developer building 6 end-to-end ML solutions. Specialized in Data Analysis and Generative AI applications across multiple domains."
    },
    {
      company: "AIEDUTECH",
      role: "Co-founder & CTO",
      duration: "Jan 2023 - Present",
      description: "Co-founded and led technical development of AI-powered educational technology tools. Trained +1500 teachers from +100 schools on AI and Educational Technology."
    },
    {
      company: "Gaia Consulting",
      role: "External Data & GenAI Consultant",
      duration: "Dec 2022 - June 2025",
      description: "Strategic AI consulting and pipeline integration. Crafted advanced pipelines reducing data processing times by 54%, deployed NLP solutions reducing manual sorting by 75%."
    }
  ],

  sideProjects: [
    // 4 primeros
    //{    // mi TFG → PENDIENTE traducir abstract+ppt(sin numeros, solo resultados) y poner esp/english
    //  title: "AI point cloud ................",
    //  description: ".",
    //  tech: ["AI", "LiDAR", "AWS", "Unsupervised"]
    //},
    {
      title: "Database querier with MCP",
      description: "Query databases in natural language via MCP. One example of the many useful MCP servers found.",
      tech: ["MCP", "Databases", "AI", "LLMs"],
      photo: "/projects/mcp.webp",
      links: [{ type: "Medium", url: "https://medium.com/@jonortega20/building-a-database-querier-with-mcp-17df0f49a2de" }, { type: "Github", url: "https://github.com/jonortega20/mcp-sql-query" }]
    },
    {
      title: "Brain tumor classification with Transformers",
      description: "Applying Transfer Learning and Vision Transformers to classify brain tumors in 7 classes, achieving a 94% accuracy.",
      tech: ["Computer Vision", "Transfer Learning"],
      photo: "/projects/brains.png",
      links: [{ type: "pdf", url: "Transfer_Learning_for_brain_tumor_classification_RESULTS.pdf", label: "Results" }, { type: "ipynb", url: "https://drive.google.com/file/d/1w_C7ZVBIeKF_5Pbad_GKJUvctaHgicNZ/view?usp=sharing" }]
    },
    {
      title: "Graph Neural Networks for outfit recommendation",
      description: "Built an outfit recommender assembling 3-piece looks with GNNs. Graph-based analysis and prediction, and image generation for preview.",
      tech: ["GNNs", "Computer Vision", "GenAI"],
      photo: "/projects/lookiero.jpg",
      links: [{ type: "pdf", url: "GNNs_project_summary.pdf", label: "Summary" }]
    },
    {
      title: "Candidate-job matching with embedding similarity",
      description: "Match candidates to job openings using BERT embeddings and cosine similarity across CVs, interview transcripts and LinkedIn data.",
      tech: ["Embeddings", "LLMs", "GenAI"],
      photo: "/projects/embedding_graph.png",
      links: [{ type: "PNG", url: "CV_job-offer matching.PNG" }]
    },

    // OTROS (¿meter segunda fila?)
    {}, // Scouting for basketball players → PENDIENTE traducir y poner esp/english
    {
      title: "SEO Content Agent",
      description: "AI agent for generating SEO-optimized blog posts. Currently in production at wrappers.es/blog with automated content generation pipeline.",
      tech: ["LangChain", "OpenAI", "SEO", "Content Generation"],
    },
    {}, // Invoice processing
    {
      title: "Python Library AutoPrep",
      description: "Automated data preprocessing library that streamlines ML pipeline preparation with intelligent feature engineering.",
      tech: ["Python", "ML", "Automation", "Feature Engineering"]
      //pipy link & github repo
    },
    {} // Agente debugger de logs con langgraph → ÑEH
  ],

  technologies: {
    aiMl: ["MCP", "AI Agents", "CrewAI", "LangGraph", "RAG", "OpenAI API", "TensorFlow", "PyTorch", "Computer Vision", "NLP", "BERT", "Neural Networks", "Boosting"],
    dataScience: ["Python", "R", "Pandas", "NumPy", "Scikit-learn", "Jupyter", "Plotly", "Matplotlib", "Data Analysis", "Statistical Modeling"],
    backend: ["FastAPI", "Flask", "Node.js", "PostgreSQL", "MongoDB", "MySQL", "Redis", "Docker", "Microservices"],
    frontend: ["NextJS", "React", "TypeScript", "JavaScript", "HTML", "CSS", "Tailwind CSS", "Responsive Design"],
    cloud: ["AWS", "Docker", "CI/CD", "DevOps", "Kubernetes", "Hadoop", "Spark", "Elasticsearch", "Linux"],
    tools: ["Git", "GitHub", "APIs", "Trello", "Azure DevOps", "Postman", "Analytics", "GA4"]
  },

  blogPosts: [
    {
      title: "2025 Wrapped: You Can Just Do Things",
      platform: "Medium",
      url: "https://medium.com/@jonortega20/2025-wrapped-you-can-just-do-things-c33e9f6d41c5",
      //image: "/posts/2025-wrapped.png",
      image: "/posts/silicon-valley.jpg",
      description: "I did many things in 2025, here's a summary of the most important ones.",
      date: "2025"
    },
    //{
    //title: "My Silicon Valley experience",
    //platform: "Medium",
    //url: "https://medium.com/@jonortega20/reflections-on-my-silicon-valley-experience-5c9d9540f1b6",
    //image: "/posts/silicon-valley.jpg",
    //description: "Highlights from my time in the Valley, what I saw and learned.",
    //date: "2025"
    //},
    {
      title: "How I envision the future with AGI",
      platform: "Medium",
      url: "https://medium.com/@jonortega20/how-i-envision-the-future-with-agi-6874bde0825a",
      image: "/posts/agi-future.png",
      description: "My personal vision on how future interfaces will look like.",
      date: "2025"
    },
    {
      title: "Podcast: How Wrappers AI started (in spanish)",
      platform: "YouTube",
      url: "https://www.youtube.com/watch?v=9sTEf3BKumM",
      image: "/posts/podcast.png",
      description: "El origen de Wrappers AI y decisiones que resultaron ser clave.",
      date: "2025"
    }
  ],

  socialLinks: [
    { name: "Email", url: "mailto:jonortega20@gmail.com", icon: "Mail" },
    { name: "LinkedIn", url: "https://www.linkedin.com/in/jon-ortega-uzquiaga", icon: "Linkedin" },
    { name: "GitHub", url: "https://github.com/jonortega20", icon: "Github" },
    { name: "X (Twitter)", url: "https://x.com/jon__ortega", icon: "X" },
    { name: "Medium", url: "https://medium.com/@jonortega20", icon: "BookOpen" }
  ]
};

export const navigationItems = [
  { id: "home", label: "Home", href: "#home" },
  { id: "wrappers", label: "Startup", href: "#wrappers" },
  { id: "projects", label: "Projects", href: "#projects" },
  { id: "experience", label: "Experience", href: "#experience" },
  { id: "tech", label: "Technologies", href: "#tech" },
  { id: "posts", label: "Posts", href: "#posts" },
  { id: "mindset", label: "Mindset", href: "#mindset" },
  { id: "contact", label: "Contact", href: "#contact" }
];